<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">新增</el-button>
          </div>
        </zv-table>

        <zv-dialog
          width="400px"
          :title="isEdit ? '修改App' : '新增App'"
          :showDialog.sync="showFormDialog"
          @close-dialog="closeFormDialog"
        >
          <div slot="content">
            <el-form
              ref="myForm"
              label-width="140px"
              :model="formData"
              :rules="formRules"
              status-icon
            >
              <el-form-item label="App名称：" prop="app_name">
                <el-input v-model="formData.app_name" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
          </div>
        </zv-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import TipUtil from "@/utils/utils/TipUtil";
import addFormMixin from "@/mixins/addFormMixin";
export default {
  name: "AppList",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      table: {
        api: api.appList,
        query: {

        },
        searchData: [
          {
            // type: "input",
            // model: "app_name",
            // placeholder: "App名称"
          }
        ],
        columns: [
          {
            title: "App名称",
            key: "app_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "修改"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {

                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"

              );

              const resetBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {

                    click: vm.resetTokenClick.bind(this, ctx.row.id)
                  }
                },

                "重置token"

              );

              let arr = [];
              arr.push(editBtn);

              arr.push(delBtn);

              arr.push(resetBtn)

              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
        app_name: ''
      },
      formRules: {
        app_name: [{
          required: true,
          message: "App名称不能为空",
          trigger: "blur"
        }]
      },
      adddApi: api.addApp,
      editApi: api.editApp,
      deleteApi: api.deleteApp,
      addSuccessMsg: '添加App成功',
      editSuccessMsg: '编辑App成功',
      deleteSuccessMsg: '删除App成功',
      deleteKey: 'app_id'
    };
  },

  computed: {

  },

  methods: {
    dealEditItem(editItem) {
      let retObj = this.$_.cloneDeep(editItem)
      retObj.app_id = parseInt(retObj.id)
      return retObj
    },

    async resetTokenClick(id) {
      await TipUtil.confirm('确定重置token?', '提示');
      let res = await api.resetToken({
        app_id: id
      })

      console.log(res)
      TipUtil.message('App token重置成功！')
    }
  },

  created() {
  },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>

</style>
